import { useState } from 'react';
import ArAgingReports from './ArAgingReports/ArAgingReports';
import PaymentsDataReporting from './PaymentsDataReporting/PaymentsDataReporting';
import CreditApplicationsDataReports from './CreditApplicationsDataReports/CreditApplicationsDataReports';
import ApplicationCountsReports from './ApplicationCountsReports/ApplicationCountsReports';
import PreliminaryNoticesReporting from './PreliminaryNoticesReporting/PreliminaryNoticesReporting';
import InvoiceCollectionNotesReports from './InvoiceCollectionNotesReports/InvoiceCollectionNotesReports';

type CreditApplicationsSubTab = 'applications' | 'applicationCounts';

const creditApplicationsSubTabs = [
  { id: 'applications' as CreditApplicationsSubTab, label: 'Applications' },
  { id: 'applicationCounts' as CreditApplicationsSubTab, label: 'Application Counts' },
];

type ReportTab =
  | 'arAgingReports'
  | 'invoiceCollectionNotes'
  | 'dillPaymentsReport'
  | 'payments'
  | 'creditApplications'
  | 'customerAnalytics'
  | 'creditApplicationsReport'
  | 'customerAccountPreview'
  | 'preliminaryNotices';

function SupplierReporting() {
  const [activeTab, setActiveTab] = useState<ReportTab>('arAgingReports');
  const [creditApplicationsSubTab, setCreditApplicationsSubTab] =
    useState<CreditApplicationsSubTab>('applications');

  const tabs = [
    { id: 'arAgingReports' as ReportTab, label: 'AR Aging' },
    { id: 'invoiceCollectionNotes' as ReportTab, label: 'Invoice Collection Notes' },
    { id: 'dillPaymentsReport' as ReportTab, label: 'Dill Payments' },
    { id: 'creditApplicationsReport' as ReportTab, label: 'Credit Applications' },
    { id: 'preliminaryNotices' as ReportTab, label: 'Preliminary Notices' },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'creditApplicationsReport':
        return (
          <>
            <div className="pt-4">
              <div role="tablist" className="inline-flex rounded-lg bg-gray-100 p-1 gap-1">
                {creditApplicationsSubTabs.map((subTab) => (
                  <button
                    key={subTab.id}
                    role="tab"
                    aria-selected={creditApplicationsSubTab === subTab.id}
                    onClick={() => setCreditApplicationsSubTab(subTab.id)}
                    className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors cursor-pointer ${
                      creditApplicationsSubTab === subTab.id
                        ? 'bg-white text-blue-600 shadow-sm'
                        : 'bg-transparent text-gray-500 hover:text-gray-700'
                    }`}>
                    {subTab.label}
                  </button>
                ))}
              </div>
            </div>
            {creditApplicationsSubTab === 'applications' ? (
              <CreditApplicationsDataReports />
            ) : (
              <ApplicationCountsReports />
            )}
          </>
        );
      case 'arAgingReports':
        return <ArAgingReports />;
      case 'invoiceCollectionNotes':
        return <InvoiceCollectionNotesReports />;
      case 'dillPaymentsReport':
        return <PaymentsDataReporting />;
      case 'preliminaryNotices':
        return <PreliminaryNoticesReporting />;
      default:
        return <PaymentsDataReporting />;
    }
  };

  return (
    <div className="flex flex-col w-full h-full">
      {/* Tab Navigation with Year Selector */}
      <div className="sticky top-0 bg-white z-30 border-b border-gray-200">
        <div className="px-4">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              role="tab"
              aria-selected={activeTab === tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors cursor-pointer bg-transparent ${
                activeTab === tab.id
                  ? 'border-blue-600 text-blue-600 bg-white'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex flex-col w-full h-full px-4 pb-24 overflow-scroll">
        {renderTabContent()}
      </div>
    </div>
  );
}

export default SupplierReporting;
